import React, { useEffect }  from "react";
import { Divider, Grid } from "@mui/material";
import { BiSolidPhone } from "react-icons/bi";

import CustomInput from "../../Components/CustomInputs/CustomInputs";
import CustomCheckBox from "../../Components/CheckBox/CustomCheckBox";
import CustomDropDown from "../../Components/DropDown/CustomDropDown";
import TextAreaField from "../../Components/CustomInputs/TextArea";
// import AutoComplete from "../../Components/GoogleAutoComplete/AutoComplete";
import { Mandatory } from "../../Utils/index"
const CandidateOtherDetails = ({Permanentaddeess,setPermanentaddeess,referenceDetails, setReferenceDetails,furtherInformation,physicalTest, setPhysicalTest, setFurtherInformation,otherDetails }) => {

  const HandleValueChange = (index, value, filed) => {
    const updatedInformation = [...furtherInformation];
    if ((value == "Yes" || value == "No") && filed == "value") {
      updatedInformation[index] = {
        ...updatedInformation[index],
        [filed]: value,
        name1Value: "",
        name2Value: "",
      };
    } else {
      updatedInformation[index] = {
        ...updatedInformation[index],
        [filed]: value,
      };
    }
    setFurtherInformation(updatedInformation);
  }

  const HandlePhysicalValueChange = (value, index, filed) => {
    var updatedInformation = [...physicalTest];

    updatedInformation[index] = {
      ...updatedInformation[index],
      [filed]: value,
    };
    setPhysicalTest(updatedInformation);
  }
  const HandleReferenceValueChange = (value, filed) => {
    var updatedInformation = { ...referenceDetails };
    updatedInformation = {
      ...updatedInformation,
      [filed]: value,
    };
    setReferenceDetails(updatedInformation);
  }
  useEffect(()=>{
  },[otherDetails,furtherInformation])
  const DentalConditionInfo = [
    { value: "Healthy", label: "Healthy" },
    { value: "Cavities", label: "Cavities" },
  ];
  const HandleaddressPermanent=(value)=>{
    setPermanentaddeess(value)
  }
  return (
    <Grid container item lg={12} sm={12} md={12} xs={12}>
      <Grid item container lg={12} xs={12} className="px-3" >
        <Grid item container lg={12} xs={12} justifyContent={"space-between"} alignItems={"flex-start"}>
          <Grid item container lg={12} xs={12} className="mt-3">
            <h5 className="Text-Prime-Black poppinsMedium text-left py-2">Physical Fitness Requirements</h5>
            <Divider className="m-1 w-100" sx={{ border: "1px solid #a7aba96e" }} />
          </Grid>
          {physicalTest.map((item, i) => {
            return (
              <Grid item container key={i} lg={3.8} md={3.8} sm={12} xs={12} flexDirection={"column"} className="pt-2">
                <p className="text-black poppinsMedium pb-2 text-left">{item.name} {Mandatory()} </p>

                {item.input == "text" &&
                  <CustomInput
                    width={"100%"}
                    height={"45px"}
                    placeholderColor={"#666666"}
                    padding={"2.5% 3% 2.5% 0%"}
                    border={"1px solid  #666666"}
                    fontFamily={"PoppinsMedium"}
                    type={"number"}
                    placeholder={"Enter" + " " + item.name}
                    value={item.value}
                    onChange={(e) => HandlePhysicalValueChange(e.target.value, i, "value")}
                  />}
                {item.input == "drop" &&
                  <CustomDropDown
                    placeholder={"Select Preferred Location - 3"}
                    data={DentalConditionInfo}

                    borderRadius={"8px"}
                    isSearchable={true}
                    backgroundColor="#FFFFFF"
                    selected={
                      item?.value && {
                        label: item?.value,
                        value: item?.value,
                      }
                    }
                    onChange={(e) => HandlePhysicalValueChange(e.value,i,"value")}
                  />
                }  
                {item.input == "check" &&
                  <Grid item container lg={5.9} md={5.9} sm={5.9} xs={5.9} alignItems={"center"} justifyContent={"flex-start"}>
                    <CustomCheckBox
                      disableColor={"transparent"}
                      checked={item?.value == "Yes" ? true : false}
                      onChange={() => HandlePhysicalValueChange("Yes", i, "value")}
                    />
                    <p className="poppinsRegular Text-Prime-Black text-left">Yes</p>
                    <CustomCheckBox
                      disableColor={"transparent"}
                      checked={item?.value == "No" ? true : false}
                      onChange={() => HandlePhysicalValueChange("No", i, "value")}
                    />
                    <p className="poppinsRegular Text-Prime-Black text-left">No</p>
                  </Grid>}
              </Grid>
            )
          })}

        </Grid>
        <Grid item container lg={12} xs={12} justifyContent={"space-between"} alignItems={"flex-start"}>
          <Grid item container lg={12} xs={12} className="mt-3">
            <h5 className="Text-Prime-Black poppinsMedium text-left py-2">Referee’s Information (If available)</h5>
            <Divider className="m-1 w-100" sx={{ border: "1px solid #a7aba96e" }} />
          </Grid>
          <Grid item container lg={3.8} md={3.8} sm={12} xs={12} flexDirection={"column"} className="pt-2">
            <p className="text-black poppinsMedium pb-2 text-left">Full Name</p>
            <CustomInput
              width={"100%"}
              height={"45px"}
              placeholderColor={"#666666"}
              padding={"2.5% 3% 2.5% 0%"}
              border={"1px solid  #666666"}
              fontFamily={"PoppinsMedium"}
              placeholder={"Enter Full Name"}
              value={referenceDetails.fullName}
              onChange={(e) => HandleReferenceValueChange(e.target.value, "fullName")}
            />
          </Grid>
          <Grid item container lg={3.8} md={3.8} sm={12} xs={12} flexDirection={"column"} className="pt-2">
            <p className="text-black poppinsMedium pb-2 text-left">Phone</p>
            <CustomInput
              placeholder="E.g. XXX XXX XXXX"
              backgroundColor="#FFFFFF"
              width={"100%"}
              height={"45px"}
              placeholderColor={"#666666"}
              padding={"2.5% 3% 2.5% 2%"}
              border={"1px solid  #666666"}
              fontFamily={"PoppinsMedium"}
              maxLength={10}
              type="number"
              value={referenceDetails.Phone}
              InputFrontProps={<p className="Text-Prime-Black poppinsMedium pr-2 " style={{wordBreak:"unset"}} >+234</p>}
              InputProps={(<BiSolidPhone color={"#666666"} size={24} />)}
              onChange={(e) => HandleReferenceValueChange(e.target.value, "Phone")}
            />
          </Grid>
          <Grid item container lg={3.8} md={3.8} sm={12} xs={12} flexDirection={"column"} className="pt-2">
            <p className="text-black poppinsMedium pb-2 text-left">Address</p>
            {/* <AutoComplete  
              placeholder={"Enter  Address"}  
              Location={Permanentaddeess?.Address}
              setLocation={(e) => HandleaddressPermanent(e, 0)}
              height={"30px"}
            /> */}
            <CustomInput
              width={"100%"}
              height={"45px"}
              placeholderColor={"#666666"}
              padding={"2.5% 3% 2.5% 0%"}
              border={"1px solid  #666666"}
              fontFamily={"PoppinsMedium"}
              placeholder={"Enter  Address"}
              value={Permanentaddeess?.Address}
              onChange={(e) => HandleaddressPermanent(e.target.value, 0)}
              // onChange={(e) => HandleReferenceValueChange(e.target.value, "fullName")}
            />
          </Grid>
          <Grid item container lg={3.8} md={3.8} sm={12} xs={12} flexDirection={"column"} className="pt-2">
            <p className="text-black poppinsMedium pb-2 text-left">Give details:</p>
            <CustomInput
              width={"100%"}
              height={"45px"}
              placeholderColor={"#666666"}
              padding={"2.5% 3% 2.5% 0%"}
              border={"1px solid  #666666"}
              fontFamily={"PoppinsMedium"}
              placeholder={"Enter Details"}
              onChange={(e) => HandleReferenceValueChange(e.target.value, "Details")}
              value={referenceDetails.Details}
            />
          </Grid>
        </Grid>
        <Grid item container lg={12} xs={12} justifyContent={"space-between"} className="mt-3">
          <h5 className="Text-Prime-Black poppinsMedium text-left py-2">Further Information</h5>
          <Divider className="m-1 w-100" sx={{ border: "1px solid #a7aba96e" }} />
          <Grid item container lg={12} xs={12} justifyContent={"space-between"} className="mt-3">
            <Grid item container lg={12} display={"flex"} justifyContent={"space-between"} alignItems={"center"} className="mt-2">
              {furtherInformation?.map((item, i) => {
                return (
                  <Grid item container key={i} lg={12} display={"flex"} justifyContent={"space-between"} alignItems={"center"} className="mt-2">
                    <Grid item container lg={5.9} md={5.9} sm={5.9} xs={5.9} alignItems={"center"} justifyContent={"space-between"}>
                      <Grid item container lg={5.9} md={5.9} sm={5.9} xs={5.9} alignItems={"center"} justifyContent={"flex-start"} textAlign={"left"}>
                        <p className="poppinsMedium Text-Prime-Black ">{item.name} {Mandatory()} </p>
                      </Grid>
                      {item.input == "check" &&
                        <Grid item container lg={5.9} md={5.9} sm={5.9} xs={5.9} alignItems={"center"} justifyContent={"flex-start"}>
                          <CustomCheckBox
                            disableColor={"transparent"}
                            checked={item?.value == "Yes" ? true : false}
                            onChange={() => HandleValueChange(i, "Yes", "value")}
                          />
                          <p className="poppinsRegular Text-Prime-Black text-left">Yes</p>
                          <CustomCheckBox
                            disableColor={"transparent"}
                            checked={item?.value == "No" ? true : false}
                            onChange={() => HandleValueChange(i, "No", "value")}
                          />
                          <p className="poppinsRegular Text-Prime-Black text-left">No</p>
                        </Grid>}
                    </Grid>
                    {item.name1 &&
                      <Grid item container lg={5.9} md={5.9} sm={5.9} xs={5.9} flexDirection={"column"} className="pt-2">
                        <p className="text-black poppinsMedium pb-2 text-left">Give details (if Yes):</p>
                        <CustomInput
                          backgroundColor={item?.value == "Yes" ? "transparent" : "#EEECEC"}
                          width={"100%"}
                          height={"45px"}
                          disabled={item?.value == "Yes" ? false : true}
                          placeholderColor={"#666666"}
                          padding={"2.5% 3% 2.5% 0%"}
                          border={"1px solid  #666666"}
                          fontFamily={"PoppinsMedium"}
                          placeholder={item?.value == "Yes" ? "Enter Details" : "Not Available"}
                          value={item.name1Value}
                          onChange={(e) => HandleValueChange(i, e.target.value, "name1Value")}
               
                        />
                      </Grid>}
                    {item.name2 && item?.value == "Yes" &&
                      <Grid item container lg={5.9} md={5.9} sm={5.9} xs={5.9} flexDirection={"column"}>
                        <p className="text-black poppinsMedium pb-2 text-left">Reason for Leaving (if yes)</p>
                        <TextAreaField
                          placeholder="Enter the Details"

                          backgroundColor={item?.value == "Yes" ? "transparent" : "#EEECEC"}

                          width={"100%"}
                          maxLength={500}
                          height={"10vh"}
                          borderRadius={"4px"}
                          padding={"2.5% 3% 2.5% 0%"}
                          placeholderColor="#666666"
                          border={"1px solid  #666666"}
                          fontFamily={"PoppinsMedium"}
                          value={item.name2Value}
                          onChange={(e) => HandleValueChange(i, e.target.value, "name2Value")}
                        />
                      </Grid>}
                    {item.input == "year" &&
                      <Grid item container lg={5.9} md={5.9} sm={5.9} xs={5.9} flexDirection={"row"} alignItems={"center"} className="pt-2">
                        <Grid item container lg={5} md={5} sm={5} xs={5} alignItems={"center"} flexDirection={"row"} justifyContent={"space-between"}>
                          <Grid item lg={5.9} md={5.9} sm={5.9} xs={5.9}>
                            <CustomInput
                              height={"45px"}
                              width={"100%"}
                              placeholderColor={"#666666"}
                              padding={"2.5% 3% 2.5% 0%"}
                              border={"1px solid  #666666"}
                              fontFamily={"PoppinsMedium"}
                              placeholder="Year"
                              value={item.year}
                              onChange={(e) => HandleValueChange(i, e.target.value, "year")}
                            />

                          </Grid>
                          <Grid item lg={5.9} md={5.9} sm={5.9} xs={5.9}>
                            <p className="poppinsMedium Text-Prime-Black text-left mx-2">Year</p>
                          </Grid>
                        </Grid>

                        <Grid item container lg={5} md={5} sm={5} xs={5} alignItems={"center"} justifyContent={"flex-start"}>
                          <Grid item lg={5.9} md={5.9} sm={5.9} xs={5.9}>
                            <CustomInput
                              height={"45px"}
                              placeholderColor={"#666666"}
                              padding={"2.5% 3% 2.5% 0%"}
                              border={"1px solid  #666666"}
                              fontFamily={"PoppinsMedium"}
                              placeholder="Months"
                              value={item.month}
                              onChange={(e) => HandleValueChange(i, e.target.value, "month")}
                            />
                          </Grid>
                          <Grid item lg={5.9} md={5.9} sm={5.9} xs={5.9}>
                            <p className="poppinsMedium Text-Prime-Black text-left mx-2">Months</p>
                          </Grid>
                        </Grid>
                      </Grid>
                    }
                  </Grid>
                )
              })}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
export default CandidateOtherDetails;